import React, { useEffect, useState } from 'react'
import useUser from 'sdk/hooks/user/useUser';
import useIsAuth from 'sdk/hooks/useIsAuth';
import MessageModal from 'components/shared/modals/MessageModal';
import useResetPassword from 'sdk/hooks/user/useResetPassword';
import { Accounts } from 'sdk/hooks/user/useUserAccounts';
import EmailView from './EmailView'
import UsernameView from './UsernameView'
import SelectView from './SelectView'

enum Views { Email, Select, Username }

function PassReset({ onClose, goToSignIn, defaultView }: {
  onClose: () => void,
  goToSignIn: () => void,
  defaultView: string,
}) {
  const { isFetched: authIsFetched, data: { isAuth } } = useIsAuth()
  const userData = useUser(isAuth)

  const [view, setView] = useState<Views>((defaultView === 'Email') ? Views.Email : Views.Username)
  const [acc, setAcc] = useState<Accounts>({ email: '', phone: '', username: '' })

  const {
    mutate: resetPassword,
    error: resetPasswordError,
    isSuccess: isResetPasswordSuccess,
    isError: isResetPasswordError,
    reset: resetResetPassword,
    isLoading: isResetPasswordLoading,

  } : any = useResetPassword({
    email: '',
    options: {
      redirectTo: `${window.location.origin}/new-pass`,
    },
  })

  const goToSelect = (accounts: Accounts, forceAccPage = false) => {
    setAcc(accounts)
    if (forceAccPage || accounts.phone || !accounts.email) {
      setView(Views.Select)
    } else {
      resetPassword(accounts.email)
    }
  }

  useEffect(() => {
    if (isResetPasswordError && resetPasswordError) {
      resetResetPassword();
    }
  }, [isResetPasswordError, resetPasswordError]);

  if (!authIsFetched || userData.isFetching) {
    return null;
  }

  if (isResetPasswordSuccess) {
    return (
      <MessageModal
        title="Hang in there!"
        status="email"
        onClick={onClose}
        message="We&apos;ll send a link so you can get back into your account."
      />
    )
  }

  if (isResetPasswordError) {
    return (
      <MessageModal
        title="Error while reset pasword"
        status="error"
        onClick={onClose}
        message={resetPasswordError ? resetPasswordError?.message : 'Error occured while resetting the password. Please try again.'}
      />
    )
  }

  if (view === Views.Select) {
    return (
      <SelectView
        handleNext={() => {}}
        accounts={acc}
        onClose={onClose}
      />
    )
  }

  if (view === Views.Username) {
    return (
      <UsernameView
        handleNext={(accounts: Accounts) => goToSelect(accounts, true)}
        onClose={onClose}
        loading={isResetPasswordLoading}
        onBack={goToSignIn}
      />
    )
  }

  return (
    <EmailView
      handleNext={(accounts: Accounts) => goToSelect(accounts)}
      onClose={onClose}
      loading={isResetPasswordLoading}
      onBack={goToSignIn}
    />
  )
}

export default PassReset
